<div class="modal-container">
  <div class="modal-content">
    <h1 class="modal-title">Unsaved Changes</h1>
    <div class="modal-description">
      <p class="warning-text">
        You have unsaved changes. If you leave this page, your changes will be lost.
        Do you want to discard the changes?
      </p>
    </div>
    <div class="button-container">
      <button type="button" class="btn-stay" (click)="onStay()">Stay on Page</button>
      <button type="button" class="btn-discard" (click)="onDiscard()">Discard Changes</button>
    </div>
  </div>
</div>
